// extracted by mini-css-extract-plugin
module.exports = {"mainBox":"styles_mainBox__Gu-mD","innerContainer":"styles_innerContainer__Qu0_-","welcomeText":"styles_welcomeText__1L2f2"};